import React, { useState } from "react";
import Link from "next/link";
import Image from "next/future/image";
import { useRouter } from "next/router";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const BlogCard = ({ service, index }) => {
  const { locale } = useRouter();
  const { image, title, price, slug } = service;
  const [isHovered, setIsHovered] = useState(false);

  const blockStyle = {
    marginBottom: "25px",
    textAlign: "center",
    boxShadow: "0 0 10px #0000001a",
    borderRadius: "10px",
    height: "calc(100% - 25px)",
    transition: "0.3s",
    transform: isHovered ? "translateY(-10px)" : "translateY(0)",
  };

  const blockImgStyle = {
    borderRadius: "10px 10px 0 0",
    position: "relative",
    overflow: "hidden",
    height: "140px",
    margin: "0 auto",
    backgroundColor: "#f7f7f7",
    border: "1px solid #dfdfdf",
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "0.3s",
    transform: isHovered ? "scale(1.1)" : "scale(1)",
  };

  const linkStyle = {
    position: "absolute",
    inset: "0",
    zIndex: "1",
  };

  const contentStyle = {
    padding: "20px",
  };

  const titleStyle = {
    fontSize: "18px",
    display: "inline-block",
    fontWeight: "700",
    color: isHovered ? "#e72229" : "black",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    lineClamp: "2",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    transition: "0.3s",
  };

  return (
    <Col xs={6} sm={6} md={4} lg={3}>
      <div
        style={blockStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={blockImgStyle}>
          <Link href={`/services/${slug}`}>
            <a style={linkStyle}></a>
          </Link>
          <Image
            src={`${process.env.NEXT_PUBLIC_API_URL}/${image}`}
            alt="service-img"
            width={1920}
            height={1080}
            loading="lazy"
            quality={100}
            style={imgStyle}
          />
        </div>

        <div style={contentStyle}>
          <Link href={`/services/${slug}`}>
            <a style={titleStyle}>
              {title?.[locale].length > 50
                ? title?.[locale].slice(0, 50) + "..."
                : title?.[locale].slice(0, 50)}
            </a>
          </Link>
          {/* <p>
            <span>{price}</span> <FormattedMessage id="sar" />
          </p> */}
        </div>
      </div>
    </Col>
  );
};

export default BlogCard;
